import React from "react"

import { Box, Typography } from "@mui/material"

const HomePage = () => (
  <Box alignItems="center" display="flex" flexGrow="1" justifyContent="center">
    <Typography color="text.secondary" maxWidth="250px" textAlign="center">
      Welcome to D2 Activity Reports. Search for a Bungie name to get started.
    </Typography>
  </Box>
)

export default HomePage
